import { render, staticRenderFns } from "./dm.vue?vue&type=template&id=2e12422f"
import script from "./dm.ts?vue&type=script&lang=js&external"
export * from "./dm.ts?vue&type=script&lang=js&external"
import style0 from "./dm.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports